import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  ProfileFieldGrid,
  ProfileNotificationRow,
  ProfileMainWrapper,
  ProfileNotifcationColumns,
  ProfileNotifcationDescription,
  ProfileNotifcationDescriptionRow,
  ProfileNotifcationTitle,
} from "./Profile.styles";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { getUserAuth } from "../../recoil/selectors";
import { CustomSwitch } from "../shared/CustomSwitch";
import { UpdateNotifications } from "./Services/UpdateProfileInfoService";
import { patientProfileState } from "../../recoil/atoms";

export const ProfileNotifications: React.FC = () => {
  const { t } = useTranslation();
  const authInfo = useRecoilValue(getUserAuth);
  const [profileInfo, setProfileInfo] = useRecoilState(patientProfileState);
  const [isMarketingSubscribed, setIsMarketingSubscribed] = useState(
    profileInfo?.phi.is_marketing_subscribed ?? false,
  );

  useEffect(() => {
    const updateNotifcationSettings = async () => {
      // Marketing toggle controls both marketing AND SMS subscriptions:
      // ON  → subscribes to both marketing emails and SMS
      // OFF → unsubscribes from both
      // Backend enforces this in RequisitionNotificationService.update_notification_settings:
      // if is_marketing_subscribed=False, forces is_portal_marketing_sms_subscribed=False
      const response = await UpdateNotifications(
        isMarketingSubscribed,
        isMarketingSubscribed,
        authInfo?.access_token,
      );
      if (response?.ok) {
        const responseJson = await response.json();
        setProfileInfo(responseJson);
      }
    };
    if (profileInfo?.phi.is_marketing_subscribed !== isMarketingSubscribed) {
      updateNotifcationSettings();
    }
  }, [isMarketingSubscribed]);

  return (
    <>
      {profileInfo && authInfo && (
        <ProfileMainWrapper>
          <div>
            {GetTypographyContent({
              content: t("profile.notifications.title"),
              size: "h3",
              textColor: "greyMedium",
              isBold: true,
            })}
            <ProfileNotifcationDescription>
              {t("profile.notifications.description")}
            </ProfileNotifcationDescription>
          </div>
          <ProfileFieldGrid>
            <ProfileNotificationRow>
              <ProfileNotifcationColumns
                onClick={() => setIsMarketingSubscribed(!isMarketingSubscribed)}
              >
                <CustomSwitch clicked={isMarketingSubscribed} />
                <ProfileNotifcationDescriptionRow>
                  <ProfileNotifcationTitle>
                    {t("profile.notifications.marketing.title")}
                  </ProfileNotifcationTitle>
                  <ProfileNotifcationDescription>
                    {t("profile.notifications.marketing.description")}
                  </ProfileNotifcationDescription>
                </ProfileNotifcationDescriptionRow>
              </ProfileNotifcationColumns>
            </ProfileNotificationRow>
          </ProfileFieldGrid>
        </ProfileMainWrapper>
      )}
    </>
  );
};
